var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.5V6C6.5 5.60218 6.34196 5.22064 6.06066 4.93934C5.77936 4.65804 5.39782 4.5 5 4.5C4.60218 4.5 4.22064 4.65804 3.93934 4.93934C3.65804 5.22064 3.5 5.60218 3.5 6V9.5",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5C14 10.1865 11.3135 7.5 8 7.5C4.6865 7.5 2 10.1865 2 13.5V19.5H14M14 13.5V19.5M14 13.5H22V19.5H14",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C9.10457 15.5 10 14.6046 10 13.5C10 12.3954 9.10457 11.5 8 11.5C6.89543 11.5 6 12.3954 6 13.5C6 14.6046 6.89543 15.5 8 15.5Z",
    stroke: "#435B37",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.5V15.5M16.5 13.5V15.5M15 13.5H21",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaCollapseIcon);
export default __webpack_public_path__ + "static/media/CACollapseIcon.f0bbb2351873625e220c2c8e55608b2e.svg";
export { ForwardRef as ReactComponent };